<template>
  <div>
            <div
              v-for="(tab, key) in tabs"
              class="ml-3 d-inline it-tabs pb-2"
              :class="tab.id === tabSelected ? 'active' : ''"
              :key="key"
            >
              <a class="cursor-pointer d-inline" :class="tab.disabled ? 'disabledDiv' : ''" @click="changeTab(tab.id)">
                <i v-if="tab.icon" :class="tab.icon"></i>
                {{ tab.name }}
              </a>
            </div>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
export default {
  props: {
    tabs:Object,
    tabSelected:Number
  },

  computed: {
  },
  created() {

  },

  methods: {
    ...mapActions("header", {
      changeHeaderTab: "changeTab",
    }),
    changeTab(id) {
      this.$emit("change",id)
    },
  },
};
</script>
<style scoped>
.disabledDiv {
    pointer-events: none;
    opacity: 0.4;
}
</style>
